import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import ui from '@alpinejs/ui'

window.Alpine = Alpine;
Alpine.plugin(focus)
Alpine.plugin(ui)
Alpine.start();

/** Initialisation de la page d'accueil */
if(document.body.classList.contains('home')){
  import('./js/home')
  .then(({ initSearchBar, initSwiper }) => {
    initSearchBar();
    initSwiper();
  })
}
